import Styles from "./AppInputNumber.module.scss";
import Column from "../Column";
import Row from "../Row";
import Title from "../Title";
import { InputNumber, InputNumberProps } from "antd";

interface AppInputNumberProps extends InputNumberProps {
  currentValue?: number;
  label?: string;
  isRequired?: boolean;
  onChangeValue?: (value: number) => void;
  errorText?: string;
  alwaysShowLabel?: boolean;
  orientation?: "col" | "row";
}

function AppInputNumber(props: AppInputNumberProps) {
  const {
    currentValue,
    label,
    isRequired,
    onChangeValue,
    errorText,
    alwaysShowLabel = true,
    orientation = "row",
    ...rest
  } = props;

  const Wrap = orientation === "row" ? Row : Column;

  return (
    <Column className="h-100 w-100">
      <Wrap className="h-100 w-100 gap-1">
        {alwaysShowLabel && label && <Title isRequired={isRequired} label={label} />}

        <div className={`${Styles.inputNumber} flex-1`}>
          <InputNumber
            className={`w-100 `}
            status={!!errorText ? "error" : ""}
            value={currentValue}
            type="number"
            placeholder={"Enter number"}
            onChange={(e) => onChangeValue?.(Number(e)!)}
            {...rest}
          />
        </div>
      </Wrap>

      {errorText && (
        <small
          className={`${Styles.smallTextError} text-error pb-1`}
          style={!alwaysShowLabel || !label || orientation === "col" ? {} : { marginLeft: 120 }}
        >
          {errorText}
        </small>
      )}
    </Column>
  );
}

export default AppInputNumber;
